import BenefitsMilitaryPersonnel from './views/benefits-military-personnel.c';
export default BenefitsMilitaryPersonnel;
